<div class="row margin-bottom-20">
	<div fxFlex fxLayoutGap="5px">
		<button id="edit-pay" (click)="navigate(0)" mat-raised-button color="primary">
			Create New Pay Table
		</button>
		<div fxFlex></div>
		<button class="form-button" color="primary" mat-raised-button (click)="navigateSetting()">
			Edit Global Pay Settings
		</button>
	</div>
</div>

<div *ngIf="payScales && payScales.length" fxLayout="row" fxLayoutAlign="center center">
	<mat-form-field class="input-full-width">
		<input matInput type="text" placeholder="Filter by Job title or Aircraft modal" [(ngModel)]="searchText" />
		<button mat-button *ngIf="searchText" matSuffix mat-icon-button aria-label="Clear" (click)="searchText = ''">
			<mat-icon>close</mat-icon>
		</button>
	</mat-form-field>
</div>

<div class="pilot-pay-tables" fxLayout="row wrap">
	<div *ngIf="!payScales || !payScales.length">
		<mat-card>
			<mat-card-content class="card-content">
				<div *ngIf="isLoading">Loading pay tables</div>
				<div *ngIf="!isLoading">There are no pay tables available.</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div
		fxFlex.sm="100%"
		fxFlex.xs="100"
		fxFlex.md="33.33%"
		fxFlex.lg="33.33%"
		fxFlex.xl="33.33%"
		fxFlex="100%"
		*ngFor="let payScale of payScales | filter: searchText:'jobTitle':'aircraftModel'"
	>
		<app-pay-scale-card [payScale]="payScale"></app-pay-scale-card>
	</div>
</div>
